
/*运维工具处理*/
import {getPatrolData,addOperationProject,searchOperationProject,updateOperationProject,getAllRepair,getRepairCount,deleteOperationProject,getAllOpsFaultType} from './apis/operatoin.js'

export default class Operation {
	constructor(proc){
		this.proc = proc;
	}

	// 添加
	addProject(data,type){
		if(type == 'add'){
			return addOperationProject(data)
		}else if(type == 'update'){
			return updateOperationProject(data)
		}
	}

	// 搜索
	searchProject(keyword){
		return searchOperationProject(keyword)
	}

	/**
	 * @enum
	 * @readonly
	 * @property {number} order 派单
	 * @property {number} onWay 维修在途
	 * @property {number} other 表示第三方维修
	 * @property {number} accessories 等待配件
	 * @property {number} audit 表示等待审核
	 * @property {number} success 表示完成
	 */
	RepairStatus = {
		'order':0,
		'onWay':1,
		'other':2,
		'accessories':3,
		'audit':4,
		'success':5,
	}

	async getAllRepair(data){
		let res = await getAllRepair({
			RepairType:0,
			...data
		})
		return res;
	}

	async getRepairCount(){
		let res = await getRepairCount()

		return res.data;
	}

	/**
	 * 删除运维项目
	 * @param {any} id 
	 * @returns 
	 */
	async removeOpsProject(id){
		let res = await deleteOperationProject(id)
		return res.data
	}

	/**
	 * 获取所有故障类型
	 * @returns 
	 */
	async getAllOpsFaultType(){
		let res = await getAllOpsFaultType()
		return res.data ||[]
	}
/**
 * 获取所有巡检数据
 */
	async getAllPatrolData(){
		let that = this;
		// 当前页
		let currentPage = 1;
		// 总分页数
		let totalPage = 0;
		const func = async function(){
			let res = await that.getPatrolData()
			currentPage = res.currentPage;
			totalPage = res.totalPage;
		}
	}
	/**
	 * 获取巡检数据
	 * @param {object} data 
	 * @returns 
	 */
	async getPatrolData(data){
		let res = await getPatrolData(data)
		return res
	}
}